import { render } from "./SyncPanel.vue?vue&type=template&id=15197755"
import script from "./SyncPanel.vue?vue&type=script&lang=js"
export * from "./SyncPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__